'use client'

import { useEffect, useState } from 'react'
import { ProductPageType } from '@productsite-beta/src/components/product-page'
import { GetProductReviewPagesQuery } from '@productsite-beta/src/graphql/generated/graphql-types'
import getProductReviewsNextPage from '@productsite-beta/src/components/get-products-reviews-next-page'

export const useProductReviewsNextPage = (
  productErpIdentifier: ProductPageType['productErpIdentifier'],
  isVisible: boolean,
  fetchPage: boolean,
  setFetchPage: (arg0: boolean) => void,
  pageQuery: string | undefined
) => {
  const [nextPageData, setProductReviewsData] = useState<GetProductReviewPagesQuery | null>(null)
  const [nextPageError, setProductReviewsError] = useState<string | null>(null)
  const [nextPageLoading, setProductReviewsIsValidating] = useState<boolean>(false)

  useEffect(() => {
    const fetchProductReviews = async () => {
      setProductReviewsIsValidating(true)
      try {
        const response: {
          nextPageError: string
          nextPageData: GetProductReviewPagesQuery
        } = await getProductReviewsNextPage({
          productErpIdentifier,
          isVisible,
          pageQuery,
        })

        setProductReviewsData(response.nextPageData)
        setProductReviewsError(null)
        setProductReviewsIsValidating(false)
        setFetchPage(false)
      } catch (error: Error | unknown) {
        setProductReviewsData(null)
        setProductReviewsError((error as Error)?.message ?? 'An error occurred')
        setProductReviewsIsValidating(false)
        setFetchPage(false)
      }
    }
    if (fetchPage) {
      fetchProductReviews()
    }
  }, [isVisible, fetchPage])

  return { nextPageData, nextPageError, nextPageLoading }
}
